import { ProductShotControlSections } from '../components/product/ProductShotControlSections';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { buildProductShotControlPageSchema } from '../lib/schema';
import { PRODUCT_SHOT_CONTROL_META } from '../lib/seo';
import '../styles/product-landing.css';

export function ProductShotControlPage() {
  return (
    <>
      <PageSeo meta={PRODUCT_SHOT_CONTROL_META} />
      <JsonLd data={buildProductShotControlPageSchema()} />
      <MarketingLandingShell>
        <ProductShotControlSections />
      </MarketingLandingShell>
    </>
  );
}
